import { render } from "./ReferenceListItem.vue?vue&type=template&id=0d35cf50"
import script from "./ReferenceListItem.vue?vue&type=script&lang=js"
export * from "./ReferenceListItem.vue?vue&type=script&lang=js"

import "./ReferenceListItem.vue?vue&type=style&index=0&id=0d35cf50&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__